<mat-expansion-panel expanded="true">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <a class="icon-link" (click)="onTableEvent($event, closeTable)" matTooltip="Close Table"><mat-icon>close_small</mat-icon></a>
      <ip-icon [ipType]="ipType"></ip-icon>
      @switch (ipType) {
        @case ('Reference') {
          Reference Library &nbsp;|&nbsp;
        }
        @default {
          <a
            class="case-number"
            (click)="onItemEvent($event, openFTF)"
            [matTooltip]="'Open &quot;' + identifier + '&quot; In First to File'"
            >{{ identifier }}</a
          >&nbsp;|&nbsp;
        }
      }
      {{ relFileGroup.display }}
    </mat-panel-title>
    @if (item && item.caseUrl) {
      <a class="icon-link" (click)="onItemEvent($event, openIPMS)" matTooltip="Open in IPMS">
        <mat-icon>open_in_new</mat-icon>
      </a>
    }
  </mat-expansion-panel-header>

  <mat-table [dataSource]="dataSource">
    <!-- Checkbox Column -->
    <ng-container matColumnDef="select">
      <mat-header-cell *matHeaderCellDef>
        <mat-checkbox
          (change)="$event ? toggleAllRows($event) : null"
          [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()"
        >
        </mat-checkbox>
      </mat-header-cell>
      <mat-cell *matCellDef="let row" [formGroup]="row">
        <mat-checkbox (change)="onSelectChange($event, row)" [checked]="selection.isSelected(row)"> </mat-checkbox>
      </mat-cell>
    </ng-container>

    <!-- File name Column -->
    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef> Filename </mat-header-cell>
      <mat-cell *matCellDef="let f" [formGroup]="f">
        <div class="name-container">
          @if (f.get('name'); as ctrl) {
            <mat-form-field [ngClass]="{ 'hide-errors': f.hasError('duplicateFilename') || f.hasError('dataFileError') }">
              <div class="input-with-icon">
                @if (f.hasError('dataFileLoading')) {
                  <div class="loading-balls" matTooltip="Loading data...">
                    <div class="tiny-ball"></div>
                    <div class="tiny-ball"></div>
                    <div class="tiny-ball"></div>
                  </div>
                }
                <img class="doc-icon" [attr.src]="'assets/doc-icons/icon-' + getTrifoldDocIcon(f) + '.png'" alt="icon" />
                <input matInput formControlName="name" />
              </div>
              @if (ctrl.hasError('required')) {
                <mat-error matTooltip="Filename is required" class="self-truncating-error-text">Filename is required</mat-error>
              }
              @if (ctrl.hasError('invalidName')) {
                <mat-error
                  matTooltip='The following characters are not allowed in a filename: &lt;, &gt;, :, ", /, \, |, ?, and *.'
                  class="self-truncating-error-text filename-invalid-error-text"
                >
                  <mat-icon class="filename-invalid-error-icon" aria-hidden="true">error</mat-icon>
                  Filename contains invalid characters
                </mat-error>
              }
              @if (ctrl.hasError('extensionMismatch')) {
                <mat-error matTooltip="Filename must end with .{{ ctrl.getError('extensionMismatch') }}" class="self-truncating-error-text"
                  >Filename must end with .{{ ctrl.getError('extensionMismatch') }}</mat-error
                >
              }
              @if (ctrl.hasError('invalidByteLength')) {
                <mat-error matTooltip="Filename is too long" class="self-truncating-error-text">Filename is too long</mat-error>
              }
              @if (f.get('fileNameTruncated')?.value) {
                <mat-hint matTooltip="Filename was automatically truncated to fit maximum length" class="hint-as-error"
                  >Filename was auto-truncated</mat-hint
                >
              }
            </mat-form-field>
          }
          @if (f.hasError('duplicateFilename')) {
            <mat-error class="non-mat-field-error self-truncating-error-text" matTooltip="Duplicate Filename found"
              >Duplicate Filename found</mat-error
            >
          }
          @if (f.hasError('dataFileError')) {
            <mat-error class="non-mat-field-error self-truncating-error-text" matTooltip="Problem getting data from Outlook"
              >Problem getting data from Outlook</mat-error
            >
          }
        </div>
      </mat-cell>
    </ng-container>

    <!-- Title Column -->
    <ng-container matColumnDef="title">
      <mat-header-cell *matHeaderCellDef> Title </mat-header-cell>
      <mat-cell *matCellDef="let f" [formGroup]="f">
        <div class="name-container">
          @if (f.get('title'); as ctrl) {
            <mat-form-field [ngClass]="{ 'hide-errors': f.hasError('duplicateReferencename') || f.hasError('caseReferenceNotAssociated') }">
              <div class="input-with-icon">
                <input matInput formControlName="title" />
              </div>
              @if (ctrl.hasError('required')) {
                <mat-error matTooltip="Title is required" class="self-truncating-error-text">Title is required</mat-error>
              }
              @if (ctrl.hasError('invalidByteLength')) {
                <mat-error matTooltip="Title is too long" class="self-truncating-error-text">Title is too long</mat-error>
              }
              @if (ctrl.hasError('pattern')) {
                <mat-error matTooltip='The following characters are not allowed in a title: " and \.' class="self-truncating-error-text"
                  >Title contains invalid characters</mat-error
                >
              }
              @if (f.get('titleTruncated')?.value) {
                <mat-hint matTooltip="Title was automatically truncated to fit maximum length" class="hint-as-error"
                  >Title was auto-truncated</mat-hint
                >
              }
            </mat-form-field>
          }
          @if (f.hasError('duplicateReferencename')) {
            <mat-error class="non-mat-field-error self-truncating-error-text" matTooltip="Reference already exists in reference library"
              >Reference already exists in reference library</mat-error
            >
          }
          @if (f.hasError('caseReferenceNotAssociated')) {
            <mat-error class="non-mat-field-error self-truncating-error-text" matTooltip="association??">association??</mat-error>
          }
        </div>
      </mat-cell>
    </ng-container>

    <!-- Reference Type Column -->
    <ng-container matColumnDef="referenceType">
      <mat-header-cell *matHeaderCellDef> Reference Type</mat-header-cell>
      <mat-cell *matCellDef="let f" [formGroup]="f">
        <mat-form-field>
          <mat-select panelWidth="" formControlName="referenceType">
            @for (t of getTrifoldTypes() | keyvalue; track t) {
              <mat-option [value]="t.key">{{ t.value }}</mat-option>
            }
          </mat-select>
          @if (f.get('referenceType').hasError('required')) {
            <mat-error matTooltip="Reference Type is required" class="self-truncating-error-text">Reference Type is required</mat-error>
          }
        </mat-form-field>
      </mat-cell>
    </ng-container>

    <!-- Trifold Column -->
    <ng-container matColumnDef="trifold">
      <mat-header-cell *matHeaderCellDef class="custom-header-cell-style">
        <mat-form-field style="padding-top: 5px">
          <mat-label style="width: 100%">Trifold</mat-label>
          <mat-select class="custom-mat-select" panelWidth="" (selectionChange)="applyTrifoldToAll($event)">
            @for (t of getTrifoldTypes() | keyvalue; track t) {
              <mat-option [value]="t.key">{{ t.value }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </mat-header-cell>
      <mat-cell *matCellDef="let f" [formGroup]="f">
        <mat-form-field>
          <mat-select #trifold panelWidth="" formControlName="trifold">
            @for (t of getTrifoldTypes() | keyvalue; track t) {
              <mat-option [value]="t.key" (onSelectionChange)="onTrifoldChange($event, f)">{{ t.value }}</mat-option>
            }
          </mat-select>
          @if (f.get('trifold').hasError('required') || f.get('trifold').hasError('invalidTrifold')) {
            <mat-error matTooltip="Trifold is required" class="self-truncating-error-text">Trifold is required</mat-error>
          }
        </mat-form-field>
      </mat-cell>
    </ng-container>

    <!-- Date Column -->
    <ng-container matColumnDef="date">
      <mat-header-cell *matHeaderCellDef class="custom-header-cell-style">
        <mat-form-field style="padding-top: 5px; width: 100%">
          <mat-label>Date</mat-label>
          <input matInput [matDatepicker]="headerDatepicker" placeholder="Date" (dateChange)="applyDateToAll($event.value)" />
          <mat-datepicker-toggle matIconSuffix [for]="headerDatepicker">
            <mat-icon matDatepickerToggleIcon><span class="material-symbols-outlined"> flex_direction </span></mat-icon>
          </mat-datepicker-toggle>
          <mat-datepicker #headerDatepicker></mat-datepicker>
        </mat-form-field>
      </mat-header-cell>

      <mat-cell *matCellDef="let f" [formGroup]="f">
        <mat-form-field>
          <input matInput [matDatepicker]="picker" formControlName="date" />
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          @if (f.get('date').hasError('required')) {
            <mat-error matTooltip="Date is required" class="self-truncating-error-text">Date is required</mat-error>
          }
        </mat-form-field>
      </mat-cell>
    </ng-container>

    <!-- SubType Column -->
    <ng-container matColumnDef="subType">
      <mat-header-cell *matHeaderCellDef class="custom-header-cell-style">
        <mat-form-field style="padding-top: 5px">
          <mat-label style="width: 100%">Sub-Type</mat-label>
          <mat-select class="custom-mat-select" panelWidth="" (selectionChange)="applySubTypeToAll($event)">
            @for (bucket of subTypesByDocType | keyvalue; track bucket) {
              <mat-optgroup style="font-weight: bold" [label]="bucket.key">
                @for (s of bucket.value; track s) {
                  <mat-option [value]="s.id">{{ s.name }}</mat-option>
                }
              </mat-optgroup>
            }
          </mat-select>
        </mat-form-field>
      </mat-header-cell>
      <mat-cell *matCellDef="let f; let i = index" [formGroup]="f">
        <div class="subtype-wrapper">
          <app-doc-sub-type-select
            [subtypes]="subTypesByDocType"
            [grouped]="true"
            [formControl]="f.get('subType')"
            panelWidth="600px"
            (selectionChange)="onSubTypeChange($event, f)"
          >
          </app-doc-sub-type-select>
          @if (f.get('subType').hasError('required') && f.get('subType').touched) {
            <div matTooltip="Sub-Type is required" class="subtype-error">Sub-Type is required</div>
          }
        </div>
      </mat-cell>
    </ng-container>

    <!-- Urgent Column -->
    <ng-container matColumnDef="urgent">
      <mat-header-cell *matHeaderCellDef class="urgent-header-cell-style">
        <label class="urgent-label">Urgent</label>
        <div class="urgent-checkbox-row">
          <mat-checkbox
            (change)="applyBooleanToAll('urgent', $event.checked)"
            [checked]="isAllControlSelected('urgent') === true"
            [indeterminate]="isAllControlSelected('urgent') === null"
          >
          </mat-checkbox>
          <mat-icon>
            <span class="material-symbols-outlined">flex_direction</span>
          </mat-icon>
        </div>
      </mat-header-cell>

      <mat-cell *matCellDef="let f" [formGroup]="f">
        <mat-checkbox formControlName="urgent"></mat-checkbox>
      </mat-cell>
    </ng-container>

    <!-- Technical Document Column -->
    <ng-container matColumnDef="exportControl">
      <mat-header-cell *matHeaderCellDef class="export-control-header-cell-style">
        <label class="export-control-label">Technical</label>
        <div class="export-control-checkbox-row">
          <mat-checkbox
            (change)="applyBooleanToAll('exportControl', $event.checked)"
            [checked]="isAllControlSelected('exportControl') === true"
            [indeterminate]="isAllControlSelected('exportControl') === null"
          >
          </mat-checkbox>
          <mat-icon>
            <span class="material-symbols-outlined">flex_direction</span>
          </mat-icon>
        </div>
      </mat-header-cell>

      <mat-cell *matCellDef="let f" [formGroup]="f">
        <mat-checkbox formControlName="exportControl"></mat-checkbox>
      </mat-cell>
    </ng-container>

    <!-- Doc Notes Column -->
    <ng-container matColumnDef="docNotes">
      <mat-header-cell *matHeaderCellDef> Doc Notes </mat-header-cell>
      <mat-cell *matCellDef="let f" [formGroup]="f">
        @if (f.get('docNotes'); as ctrl) {
          <mat-form-field>
            <input matInput formControlName="docNotes" />
            @if (ctrl.hasError('maxlength')) {
              <mat-error matTooltip="Notes is over max length of 1000 characters" class="self-truncating-error-text">
                Notes is over max length of 1000 characters
              </mat-error>
            }
            @if (ctrl.hasError('invalidByteLength') && !ctrl.hasError('maxlength')) {
              <mat-error matTooltip="Notes is too long" class="self-truncating-error-text"> Notes is too long </mat-error>
            }
            @if (ctrl.hasError('pattern')) {
              <mat-error matTooltip="The following characters are not allowed in a note: { and }" class="self-truncating-error-text">
                Invalid characters
              </mat-error>
            }
          </mat-form-field>
        }
      </mat-cell>
    </ng-container>

    <!-- Keywords Column -->
    <ng-container matColumnDef="keywords">
      <mat-header-cell *matHeaderCellDef> Keywords </mat-header-cell>
      <mat-cell *matCellDef="let f" [formGroup]="f">
        @if (f.get('keywords'); as ctrl) {
          <mat-form-field>
            <input matInput formControlName="keywords" />
            @if (ctrl.hasError('maxlength')) {
              <mat-error matTooltip="Keywords is over max length of 20 characters" class="self-truncating-error-text">
                Keywords is over max length of 20 characters.
              </mat-error>
            }
            @if (ctrl.hasError('invalidByteLength') && !ctrl.hasError('maxlength')) {
              <mat-error matTooltip="Keywords is too long" class="self-truncating-error-text">Keywords is too long</mat-error>
            }
          </mat-form-field>
        }
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; let i = index; columns: displayedColumns"></mat-row>
  </mat-table>
</mat-expansion-panel>
